import React from "react";

import { useTypedParams } from "react-router-typesafe-routes/dom";
import { ROUTES } from "src/routes";

import { PendingPayments } from "@pages/dashboard/PendingPayments";

const PendingPaymentsComponent = () => {
  const { participantId } = useTypedParams(ROUTES.Profile.AccountDetails);

  return (
    <div className="pt-5">
      <h4>Pending Payments</h4>
      <PendingPayments displayBanner={false} vendorId={participantId} />
    </div>
  );
};

export default PendingPaymentsComponent;
